/**
 * 
 * Usage:
 * 
 * 
 * given html in format:
 * 
 * 		<input type="checkbox" id="myfilter"/>
 * 		<div class="filters">
 * 			<div class="group">
 * 				<div class="title">
 * 					<input type="checkbox"/> Filter Group A
 * 				</div>
 * 				<input type="checkbox"/> A1
 * 				<input type="checkbox"/> A2
 * 				<input type="checkbox"/> A3
 * 			</div>
 * 		</div>
 * 
 * call filterBox on the checkbox:
 * 
 * 		$("#myfilter").filterBox();
 * 
 * 
 */
(function($){
	
	$.widget("ui.filterBox", {
		
		defaults: {
			
		},
		
		_create: function() {

			var checkbox = this.element,
				filterForm	= checkbox.parents('form'),
				filters		= filterForm.find(".filters");
			
			if(!(filters && checkbox)){
				console.error('Could not init filters, could not find checkbox or filters');
				return;
			}

			checkbox.addClass('filter_d');
			
			// hide filters box on load
			if(!filters.hasClass('is-filtered')) filters.hide();
			
			// initial enable/disable of filter group contents
			filters.find(".group").each(function(){
				var c = $(this).find(".title input");
				if(c.is(":checked")){
					c.parent().siblings().removeAttr('disabled');
				}else{
					c.parent().siblings().attr('disabled', 'disabled');
				}
			});
			
			// bind show/hide filters
			checkbox.change(function(){
				filters.removeClass('filterbox-open filterbox-closed');
				if(checkbox.is(":checked")){
					checkbox.trigger('searchfiltersopen');
					filters.slideDown("fast").addClass('filterbox-open');
				}else{
					checkbox.trigger('searchfiltersclose');
					filters.slideUp().addClass('filterbox-closed');
				}
			});
		
			// bind enable/disable filter group contents
			filters.find(".title input").change(function(){
				if($(this).is(":checked")){
					$(this).parent().siblings().removeAttr('disabled');
				}else{
					$(this).parent().siblings().attr('disabled', 'disabled');
				}
			});
			
			
		}

	});
	
})(jQuery);
